export default "__VITE_ASSET__B$bKds_9__"